import { get } from '../utils/api';
import { endpoints } from '../endpoints';
export const getCaches = () => get(endpoints.cache.get);
